<script setup>

import {defineProps, nextTick, onMounted, reactive, watch} from 'vue'
import {useRouter} from "vue-router";
const props = defineProps({
  list: Array,
});

const router = useRouter();
const goodsListInfo = reactive({
  goodsArray: []
})

watch(() => props.list, (newVal) => {
  goodsListInfo.goodsArray = newVal
})

// 跳转
function goodsDetailJump(_id, _item) {
  router.push('/detail/' + _id)
  localStorage.setItem('GoodsDetail', JSON.stringify(_item))
}

onMounted(() => {
  goodsListInfo.goodsArray = props.list
})

</script>

<template>
<div class="goodsList">
  <ul>
    <li v-for="item in goodsListInfo.goodsArray" :key="item.id" @click="goodsDetailJump(item.id,item)">
      <div class="pic">
        <img :src="item.goodsUrl" alt="">
        <div class="detail">
          <img src="@/assets/images/search2.png" alt="">
          <div>阅读更多</div>
        </div>
        <div :class="item.goodsStock > 0?'type active':'type'">{{ item.goodsStock > 0 ?'新的':'售罄' }}</div>
      </div>
      <div class="title">{{item.goodsName}}</div>
      <div class="price">$ {{item.goodsAmount}}</div>
    </li>
  </ul>
</div>
</template>

<style scoped lang="scss">
.goodsList{
  ul{
    li{
      display: inline-block;
      vertical-align: top;
      width: calc(25% - 15px);
      position: relative;
      text-align: center;
      margin: 0 20px 20px 0;
      cursor: pointer;
      &:nth-of-type(4n) {
        margin: 0 0 20px 0;
      }
      &:hover{
        .pic{
          .detail{
            opacity: 1;
          }
        }
      }
      .pic{
        position: relative;
        border-radius: 4px;
        overflow: hidden;
        max-height: 550px;
        >img{
          display: block;
          width: 100%;
        }
        .detail{
          position: absolute;
          left: 0;
          top: 0;
          z-index: 2;
          width: 100%;
          height: 100%;
          background-color: rgba(0,0,0,.6);
          transition: all .3s linear;
          opacity: 0;
          >img{
            position: absolute;
            right: 10px;
            top: 20px;
            width: 22px;
          }
          >div{
            position: absolute;
            left: 50%;
            bottom: 50%;
            transform: translate(-50%, -50%);
            -webkit-transform: translate(-50%, -50%);
            padding: 8px 14px;
            border-radius: 4px;
            border: 1px solid #fff;
            color: #fff;
          }
        }
        .type{
          position: absolute;
          left: 7px;
          top: 7px;
          z-index: 1;
          width: 50px;
          height: 50px;
          line-height: 50px;
          border-radius: 50px;
          text-align: center;
          font-size: 12px;
          background-color: rgb(221, 153, 51);
          color: rgb(255, 255, 255);
          &.active{
            background-color: rgb(129, 215, 66);
          }
        }

      }
      .title{
        font-weight: 500;
        padding: 10px 0;
        color: #333;
      }
      .price{
        color: rgb(221, 153, 51);
      }
    }
  }
}
@media screen and (max-width: 1024px) {
  .goodsList{
    ul{
      li{
        width: calc(50% - 5px);
        margin: 0 10px 20px 0;
        &:nth-of-type(2n) {
          margin: 0 0 20px 0;
        }
        .pic{
          .detail{
            background-color: rgba(0,0,0,0);
            >img{
              display: none;
            }
            >div{
              width: 100%;
              bottom: 0;
              transform: translate(-50%, 0%);
              -webkit-transform: translate(-50%, 0);
              border: none;
              background-color: #83b735;
            }
          }
        }
      }
    }
  }
}
</style>